import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { AuthContext, AuthProvider } from "./context/AuthContext";
import SignUp from "./pages/signup/SignUp";
import SignIn from "./pages/signin/SignIn";
import Navigation from "./pages/navigation/Navigation";
import Profile from "./pages/profile/Profile";
import Homepage from "./pages/home/Home";
import Explore from "./pages/explore/Explore";
import ProtectedRoute from "./components/ProtectedRoute";
import CreatePost from "./components/createPostModal/CreatePostModal";
import { useCallback, useContext, useEffect, useState } from "react";
import MobileNavigation from "./components/mobileNavigation/MobileNavigation";
import { ChatProvider } from "./context/ChatContext";
import Messages from "./pages/messages/Messages";
import Combine from "./pages/combine/Combine";
import Wardrobe from "./pages/wardrobe/Wardrobe";
import AppHeader from "./components/appHeader/AppHeader";
import Terms from "./pages/terms/Terms";
import PostShopping from "./pages/postShopping/PostShopping";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ChatProvider><Main /></ChatProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

function Main() {
  const location = useLocation();
  const { user } = useContext(AuthContext);
  const isAuthPage =
    location.pathname === "/signUp" || location.pathname === "/" || location.pathname === "/termos";
  const showAuthenticatedNavigation = user && !isAuthPage;
  const [postsVersion, setPostsVersion] = useState(0);
  const onPostCreated = useCallback(() => setPostsVersion((version) => version + 1), []);
  const [createPost, setCreatePost] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    setCreatePost(false);
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSetCreatePost = (value) => {
    setCreatePost(value);
  };

  return (
    <div
      className={`app-container ${isAuthPage ? "auth-page" : "app-shell"}`}
    >
      {createPost && (
        <CreatePost
          isVisible={createPost}
          handleSetCreatePost={handleSetCreatePost}
          onPostCreated={onPostCreated}
        />
      )}
      {showAuthenticatedNavigation && (
        <>
          <AppHeader menuOpen={menuOpen} onMenuToggle={() => setMenuOpen(true)} menuId="app-drawer" />
          <Navigation handleSetCreatePost={handleSetCreatePost} isOpen={menuOpen} onOpenChange={setMenuOpen} />
        </>
      )}
      <div className={`content ${isAuthPage ? "full-width" : ""}`}>
        <Routes>
          <Route index element={<SignIn />} />
          <Route path="signUp" element={<SignUp />} />
          <Route path="termos" element={<Terms />} />
          <Route path="posts/:postId/comprar" element={<ProtectedRoute><PostShopping /></ProtectedRoute>} />
          <Route
            path="homepage"
            element={
              <ProtectedRoute>
                <Homepage refreshVersion={postsVersion} />
              </ProtectedRoute>
            }
          />
          <Route
            path="explore"
            element={
              <ProtectedRoute>
                <Explore refreshVersion={postsVersion} />
              </ProtectedRoute>
            }
          />
          <Route
            path="messages"
            element={
              <ProtectedRoute>
                <Messages />
              </ProtectedRoute>
            }
          />
          <Route
            path="combine"
            element={
              <ProtectedRoute>
                <Combine />
              </ProtectedRoute>
            }
          />
          <Route
            path="wardrobe"
            element={
              <ProtectedRoute>
                <Wardrobe />
              </ProtectedRoute>
            }
          />
          <Route
            path="profile/:username"
            element={
              <ProtectedRoute>
                <Profile refreshVersion={postsVersion} />
              </ProtectedRoute>
            }
          />
          <Route
            path="*"
            element={
              <div style={{ padding: "2rem", textAlign: "center" }}>
                <h2>404 — Página não encontrada</h2>
              </div>
            }
          />
        </Routes>
      </div>
      {showAuthenticatedNavigation && (
        <MobileNavigation handleSetCreatePost={handleSetCreatePost} />
      )}
    </div>
  );
}

export default App;
